// extracted by mini-css-extract-plugin
export default {"contentHolder":"CmNa2w","contentFallback":"McgpqA","mobile":"FVFThi"};